import React, { useEffect, useState } from "react";
import PaymentAlert from "./PaymentAlert";

import { useUser } from "../../firebase_service/UserContext";
import {auth,db } from "../../firebase_service/firebase"
import { doc, setDoc, getDoc,Timestamp } from "firebase/firestore";


export default function PaymentButton({ amount, className, planName ,planValidity,isannual}) {
  const { user } = useUser();
  const [userName, setUserName] = useState("user name");
  const [userEmail, setUserEmail] = useState("xyz@example.com");


  const [alertMessage, setAlertMessage] = useState(null);
  const [alertType, setAlertType] = useState(null);

  const [isButtonLoading, setIsButtonLoading] = useState(false);


  

  const base_url="https://us-central1-smart-gpt-tag.cloudfunctions.net/api";

  useEffect(() => {
    const fetchUserData = async () => {
      if (user) {
        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const userData = userSnap.data();
          setUserName(userData.username || "");
          setUserEmail(userData.email || "");
        }
      }
    };
    fetchUserData();
  }, [user]);

  async function getAuthToken() {
    try {
        const user = auth.currentUser;
        if (!user) {
            throw new Error("No authenticated user");
        }
        const token = await user.getIdToken(true); // Force refresh token
        return token;
    } catch (error) {
        
        throw error;
    }
}

  const handlePayment = async () => {
    if (isButtonLoading) return; // Prevent multiple clicks
    setIsButtonLoading(true);

    if (!user) {
      setAlertMessage("Please login first.");
      setAlertType("error");
      setIsButtonLoading(false); // Reset button loading state
      return;
    }

    let token=await getAuthToken();
   
    // 1. Create order on backend
    let res;
    let order;
    try {
      res = await fetch(`${base_url}/api/create-order`, {
      method: "POST",
      headers: { 
        "Content-Type": "application/json" ,
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({ amount: amount,planName:planName}), // ₹500
    });
     order = await res.json();
    } catch (error) {
    
      setAlertMessage("Failed to create order. Please try again.");
      setAlertType("error");
      setIsButtonLoading(false); // Reset button loading state
      return;
    }

   

    // 2. Open Razorpay checkout
    const options = {
      key: "rzp_live_siKcRkfz79hxy3", // from dashboard
      amount: order.amount,
      currency: order.currency,
      name: "SMART GPT TAG",
      description: `Pay for ${planName} subscription  for ${planValidity}`,
      order_id: order.id,
      handler: async function (response) {


        let token;
        try {
            token = await getAuthToken(true);
        } catch (error) {
           
            setAlertMessage("Payment failed: Authentication error.");
            setAlertType("error");
            return;
        }

        const verifyRes = await fetch(`${base_url}/api/verify-payment`, {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        },
          body: JSON.stringify({
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature
          })
        });
        
        const result = await verifyRes.json();
        if (result.success) {
          let token;
          try {
              token = await getAuthToken(true);
          } catch (error) {
            
              alert("Payment failed: Authentication error.");
              return;
          }
          try{
            
            const res = await fetch(`${base_url}/api/processPayment`, {
              method: "POST",
              headers: {
                  "Authorization": `Bearer ${token}`,
                  "Content-Type": "application/json"
              },
              body: JSON.stringify({
                 planName:planName,
                 isAnnual:isannual
              })
            });

            const data = await res.json();

            if(data.success){
              setAlertMessage("Payment successfully received!");
              setAlertType("success");
            }else{
              setAlertMessage("❌ Payment process failed!");
              setAlertType("error");
            }
          }catch(error){
           
            setAlertMessage("❌ Payment process failed due to an internal error.");
            setAlertType("error");
          }
        } else {
          setAlertMessage("❌ Payment verification failed!");
          setAlertType("error");
        }
      },
      prefill: {
        name: userName,
        email: userEmail,
        
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.on('payment.failed', function (response){
      setIsButtonLoading(false); // Ensure button is re-enabled on payment failure
      setAlertMessage("Payment failed: " + response.error.description);
      setAlertType("error");
    });
    rzp1.open();
    setIsButtonLoading(false);


  };

  if (isButtonLoading) {
    return (
      <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex flex-col items-center justify-center z-50 animate-fade-in">
        <div className="loader animate-pulse"></div>
        <p className="text-white mt-4 text-lg animate-slide-up">Processing your payment, please do not close this tab...</p>
      </div>
    );
  }

  return (
    <>
      <button className={className} onClick={handlePayment} disabled={isButtonLoading}>
        {isButtonLoading ? "Loading..." : `Pay Now`}
      </button>
      {alertMessage && (
        <PaymentAlert
          message={alertMessage}
          type={alertType}
          onClose={() => setAlertMessage(null)}
        />
      )}
    </>
  );
}